import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Image from 'common/image'
import HowToJoin from './howtojoin'
import WhatIsNewSwiper from './whatisnew'
import { adobePageViewEvent, adobeInteractionEvent } from 'utils/adobewa'

const HomePageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const BannerContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 588px;
    background-color: #dacfb4;
    cursor: pointer;
`

export default function Home() {
    const { i18n } = useTranslation()
    const lang = i18n.language
    const configs = useSelector((state: any) => state.config.configs)
    const bannerSource =
        lang === 'zh'
            ? configs?.homepage?.banners?.desktopZh
            : configs?.homepage?.banners?.desktopEn

    useEffect(() => {
        adobePageViewEvent(lang)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            // Calculate current scroll position and window height
            const scrollY = window.pageYOffset
            const windowHeight = window.innerHeight

            // Calculate document height
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.documentElement.clientHeight
            )

            // Check if the user has scrolled to the bottom (or very close)
            // A small threshold can be added to account for potential rounding issues
            const threshold = 5 // Pixels from the bottom to consider "at bottom"
            if (scrollY + windowHeight >= documentHeight - threshold) {
                adobeInteractionEvent({
                    lang: lang,
                    eventID: `prioritysite_Scroll_Page_Bottom`,
                })

                window.removeEventListener('scroll', handleScroll)
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll)

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const redirectTo = () => {
        const targetUrl =
            lang === 'zh'
                ? 'https://sh.hkjc.com/3in1/ch/cwl-hs/?pcard-details'
                : 'https://sh.hkjc.com/3in1/en/cwl-hs/?pcard-details'
        window.open(targetUrl, '_blank')?.focus()
    }

    return (
        <HomePageContainer>
            <BannerContainer onClick={() => redirectTo()}>
                <Image
                    src={bannerSource}
                    alt="HKJC Logo"
                    fill
                    style={{ objectFit: 'cover' }}
                />
            </BannerContainer>
            <WhatIsNewSwiper />
            <HowToJoin />
        </HomePageContainer>
    )
}
